import { graphql, useStaticQuery } from 'gatsby'

import { FreightResroucesCategoryType } from '@application/Types/ComponentTypes'
import { getPageUrl } from '@application/Utils/generalUtils'
import { localizeUrl } from '@infrastructure/Url/localizeUrls/localizeUtilities'

export const useGetFreightResourceCategoriesList = (language = 'en'): FreightResroucesCategoryType[] => {
    const data = useStaticQuery(graphql`
        query {
            allStrapiFreightResourcesCategory(filter: { title: { regex: "/^((?!do-not-remove).)*$/" } }) {
                nodes {
                    items: freight_resources {
                        title
                        pageUrl
                        legacyPageUrl
                        useLegacyPageUrl
                        language
                    }
                    language
                    title
                    description {
                        data {
                            description
                            childMarkdownRemark {
                                html
                            }
                        }
                    }
                }
            }
        }
    `)

    const nodes: FreightResroucesCategoryType[] = data?.allStrapiFreightResourcesCategory.nodes.filter(
        (node: FreightResroucesCategoryType) => node.language === language
    )

    return nodes.map((node) => {
        return {
            ...node,
            items: node.items
                .filter((item) => item.language === language)
                .map((item) => ({ ...item, pageUrl: localizeUrl(language, getPageUrl(item)) })),
        }
    })
}
